import { faImages } from "@fortawesome/free-solid-svg-icons";
import ToolbarButton from "../../../components/ToolbarButton";
import React, { useCallback, useState } from "react";
import MediaSelectionModal, { MediaItem } from "../../../../../features/mediaLibrary/MediaSelectionModal";
import { dispatchInsertImageCommand } from "../../InlineImagePlugin";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

export function Media()
{
    const [editor] = useLexicalComposerContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const addImageFromMediaLibrary = useCallback((files: MediaItem[]) =>
    {
        for (const file of files)
        {
            dispatchInsertImageCommand(editor, file.path.replace('5000', '64829')); // TODO
            setIsModalOpen(false);
        }
    },
    [editor]);
    const element =
    <>
        <ToolbarButton title="TODO" icon={faImages} onClick={() => setIsModalOpen(true)} />
        <MediaSelectionModal defaultItemsChecked={[]} isOpen={isModalOpen} setIsOpen={setIsModalOpen} onSubmit={addImageFromMediaLibrary} />
    </>;
    return element;
}